import React from "react";
import { getRoleChangeConfig, getRoleCountCards } from "../orgDesign.constants";
import { getHeadcountBridge } from "../orgDesignTreeEngine";
import {
  BridgeRowStyled, CardStyled, NumStyled, LabelStyled, SubStyled, OpStyled,
  RoleCountsRowStyled, RoleCountsLabelStyled,
} from "./OrgDesignSummaryBridge.styles";

const OrgDesignSummaryBridge = ({ stats, statusCounts, roleCounts, entryOption }) => {
  if (!stats) return null;

  const { currentFtes, reductions, additions, decreasedRoles, addedRoles, netPositions } = getHeadcountBridge(stats, statusCounts);
  const roleCountCards = getRoleCountCards(roleCounts, entryOption);

  return (
    <>
      <BridgeRowStyled>
        <CardStyled>
          <NumStyled>{currentFtes}</NumStyled>
          <LabelStyled>Current FTEs</LabelStyled>
        </CardStyled>
        <OpStyled>−</OpStyled>
        <CardStyled>
          <NumStyled $color="#ea580c">{reductions}</NumStyled>
          <LabelStyled>
            Reductions
            <SubStyled>from {decreasedRoles} role(s)</SubStyled>
          </LabelStyled>
        </CardStyled>
        <OpStyled>+</OpStyled>
        <CardStyled>
          <NumStyled $color="#16a34a">{additions}</NumStyled>
          <LabelStyled>
            Additions
            <SubStyled>from {addedRoles} role(s)</SubStyled>
          </LabelStyled>
        </CardStyled>
        <OpStyled>=</OpStyled>
        <CardStyled $bg="#eff6ff">
          <NumStyled $color="#0155e7">{netPositions}</NumStyled>
          <LabelStyled>Net Positions</LabelStyled>
        </CardStyled>
      </BridgeRowStyled>

      {/* Role Count breakdown — separate from the FTE equation above, since
          Augmented has no +/−/= slot there. Same card style as the bridge/
          budget rows, just without operators, and the same "just blank
          until ready" treatment as the Budget Bar's Projected figure —
          no separate loading indicator, since it's the same sync call. */}
      {roleCountCards.length > 0 && (
        <RoleCountsRowStyled>
          <RoleCountsLabelStyled>Role Count:</RoleCountsLabelStyled>
          {roleCountCards.map(({ key, label, count, status }) => (
            <CardStyled key={key}>
              <NumStyled $accentToken={status ? getRoleChangeConfig(status, entryOption).accentToken : undefined}>{count}</NumStyled>
              <LabelStyled>{label}</LabelStyled>
            </CardStyled>
          ))}
        </RoleCountsRowStyled>
      )}
    </>
  );
};

export default OrgDesignSummaryBridge;
